import { useSelector } from "react-redux";
import { useState, useEffect } from "react";

import { isAgentPortal } from "js/utilities";
import { constructFinalAlertsArray } from "./constructFinalAlertsArray";
import { formatPolicyAlertsResponseToCarouselFriendly } from "./formatPolicyAlertsResponseToCarouselFriendly";

import { getAlerts } from "service/policy/getAlerts";
import { getCompanyWideAlertForCarousel } from "./getCompanyWideAlertForCarousel";

export const useAlertsForCarousel = (policies) => {
  const { user } = useSelector((s) => s.user);

  const [alerts, setAlerts] = useState([]);

  useEffect(() => {
    if (Array.isArray(policies) && policies.length > 0 && user?.userId) {
      Promise.all([
        getCompanyWideAlertForCarousel("authenticated"),
        getAlerts(
          isAgentPortal()
            ? // authenticated agent alerts for carousel, should include first 5 policy related alerts and first 5 company alerts
              policies.slice(0, 5)
            : // authenticated customer alerts, should include all policy related alerts and first 5 company alerts
              policies,
          user
        ),
      ]).then((responses) => {
        const compAlerts = responses[0];
        const polAlerts = responses[1];

        const formattedPolAlerts = formatPolicyAlertsResponseToCarouselFriendly(
          polAlerts,
          policies
        );

        const formattedAlerts = constructFinalAlertsArray(
          compAlerts,
          formattedPolAlerts
        );

        setAlerts(formattedAlerts);
      });
    } else {
      // unauthenticated alerts for carousel, only display first 5 company wide alerts
      getCompanyWideAlertForCarousel("unauthenticated").then((res) => {
        setAlerts(res);
      });
    }
  }, [policies, user?.userId]);

  return alerts;
};
